import { Badge } from "@/components/ui/badge";
import { usePortfolioCategories } from "@/hooks/usePortfolioCategories";
import { cn } from "@/lib/utils";

interface Props {
  slugs: string[];
  max?: number;
  className?: string;
}

const CategoryPills = ({ slugs, max, className }: Props) => {
  const { label } = usePortfolioCategories();
  const shown = max ? slugs.slice(0, max) : slugs;
  const extra = slugs.length - shown.length;
  return (
    <div className={cn("flex flex-wrap gap-1.5", className)}>
      {shown.map((s) => (
        <Badge key={s} variant="secondary" className="font-medium">
          {label(s)}
        </Badge>
      ))}
      {extra > 0 && <Badge variant="outline" className="font-medium">+{extra}</Badge>}
    </div>
  );
};

export default CategoryPills;
